import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspLineItemService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/line-item/`;

  setDefaultSeed(
    id: number,
    params = {}
  ) {
    let url = this.buildUrl(`${this.resource_url}${id}/set-default/`, "", params);
    return this.put(url, {});
  }

  activateDeactiveLineItem(
    id: number,
    action: "activate" | "deactivate",
    params = {}
  ) {
    let url = this.buildUrl(`${this.resource_url}${id}/${action}/`, "", params);
    return this.patch(url, {});
  }

  getMetaData(params){
    let url = this.buildUrl(`${this.resource_url}` + 'li-meta', "", params);
    return this.get(url)
  }

  getAllWeather(params={}){
    let url = this.buildUrl(`${this.resource_url}weather-list/` , "", params);
    return this.get(url)
  }

  getAllContextualSources(params={}){
    let url = this.buildUrl(`${this.resource_url}contextual-sources/` , "", params);
    return this.get(url)
  }

  getCostMetrics(data={}, params){
    let url = this.buildUrl(
      `${this.resource_url}generate-li-preview/`,
      "",
      params
    );
    return this.post(url, data);
  }

  getLIChangeLogs(id, params ={}) {
    let url = this.buildUrl(`${this.resource_url}${id}/change-log`, '', params);
    return this.get(url);
  }
}
